var H = require("hogan.js");
window.gettext || require("ehogan-loader/gt.js");
window.jscAdd || require("ehogan-loader/jscmanager.js");
module.exports = function() { var T = new H.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<a class=\"login-info_link login-info_link__font-size-big js-redirect-to-game-client-link\" href=\"#\">");t.b("\n" + i);t.b("    ");t.b(t.v(interpolate( gettext("Играть как %(account_name)s"), {'account_name': t.d("accountName",c,p,1)||""}, true)));t.b("\n" + i);t.b("</a>");t.b("\n");return t.fl(); },partials: {}, subs: {  }}, "<a class=\"login-info_link login-info_link__font-size-big js-redirect-to-game-client-link\" href=\"#\">\n    {{ ___104___ }}\n</a>\n", H);return T[arguments[0] instanceof Array ? "ri" : "render"].apply(T, arguments); };


//////////////////
// WEBPACK FOOTER
// ./static-source/messages/game_as.html
// module id = 197
// module chunks = 4